import React from "react";
// ANT DESIGN COMPONENTS
import { Select, Tooltip } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// INTERFACES
import { FormInputColorPickerInterface } from "../../../interfaces/Components.interface";
import { formatUuidT } from "../../../flatbuffers/display";

const FormInputColorPicker = ({ setColor, color }: FormInputColorPickerInterface) => {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = event.target.value;
    setColor(newColor);
  };

  const onChangeSelectColor = (newColor: string) => {
    setColor(newColor);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__flex" style={{ minWidth: "150px", width: "100%" }}>
      <div>
        <Select
          style={{ minWidth: "150px", width: "100%" }}
          size="small"
          onChange={(event: any) => {
            onChangeSelectColor(event);
          }}
          value={color}
          optionFilterProp="children"
          filterOption={(input: string, option: any) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {[
            { id: "#38ac68", name: "SUCCESS" },
            { id: "#2968c0", name: "INFO" },
            { id: "#fed03d", name: "WARNING" },
            { id: "#f94d4f", name: "ERROR" },
          ].map((item) => (
            <Option key={formatUuidT(item.id)} value={formatUuidT(item.id)}>
              {item.name}
            </Option>
          ))}
        </Select>
      </div>
      <div className="generalStyles__mlFix">
        <Tooltip title={t("general.selectColor")}>
          <input
            type="color"
            value={color}
            onChange={handleChange}
            style={{
              cursor: "pointer",
              width: "20px",
              height: "20px",
              padding: 0,
              borderRadius: "100px",
            }}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default FormInputColorPicker;
